import type {
  LicenceCountriesResponse,
  ProfileCategoryCountsResponse,
  ProfileResponse,
} from '@shared/schemas';

import api from '@/shared/api/api-client';

import { httpListDetailQueryGateway } from '../../_shared/infrastructure/list-detail-query.http';
import type { AiSearchResult, DiscoveredLpDetailGateway } from './discovered-lp-detail.gateway';

/** Client Discovered LP Detail → the list-scoped read endpoints (licence-scoped server-side). */
export const httpDiscoveredLpDetailGateway: DiscoveredLpDetailGateway = {
  loadList: httpListDetailQueryGateway.loadList,
  loadCommentCount: httpListDetailQueryGateway.loadCommentCount,

  fetchProfiles: async ({ listId, filters, q, page, pageSize }) => {
    let path = `/profiles?list_id=${listId}&page=${page + 1}&limit=${pageSize}`;
    if (q?.trim()) path += `&q=${encodeURIComponent(q.trim())}`;
    if (filters) path += `&filters=${encodeURIComponent(JSON.stringify(filters))}`;
    const res = await api.getRaw<ProfileResponse[]>(path);
    const rows = res.data ?? [];
    return { rows, total: res.pagination?.total ?? rows.length };
  },

  fetchCategoryCounts: (listId) =>
    api.get<ProfileCategoryCountsResponse>(`/profiles/category-counts?list_id=${listId}`),

  fetchCountries: async (listId) =>
    (await api.get<LicenceCountriesResponse>(`/profiles/countries?list_id=${listId}`)).countries,

  fetchTagSuggestions: async () =>
    (await api.get<{ tags: string[] }>('/profiles/tags/suggestions')).tags,

  interpretSearch: (query) => api.post<AiSearchResult>('/profiles/nl-search', { query }),
};
